var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItem3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H15C14.7348 14 14.4804 14.1054 14.2929 14.2929C14.1054 14.4804 14 14.7348 14 15V35C14 35.2652 14.1054 35.5196 14.2929 35.7071C14.4804 35.8946 14.7348 36 15 36H18V14Z",
    fill: "#D6B1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36H30V14H20V36ZM25 32C24.7348 32 24.4804 31.8946 24.2929 31.7071C24.1054 31.5196 24 31.2652 24 31C24 30.7348 24.1054 30.4804 24.2929 30.2929C24.4804 30.1054 24.7348 30 25 30C25.2652 30 25.5196 30.1054 25.7071 30.2929C25.8946 30.4804 26 30.7348 26 31C26 31.2652 25.8946 31.5196 25.7071 31.7071C25.5196 31.8946 25.2652 32 25 32ZM25 18C25.2652 18 25.5196 18.1054 25.7071 18.2929C25.8946 18.4804 26 18.7348 26 19C26 19.2652 25.8946 19.5196 25.7071 19.7071C25.5196 19.8946 25.2652 20 25 20C24.7348 20 24.4804 19.8946 24.2929 19.7071C24.1054 19.5196 24 19.2652 24 19C24 18.7348 24.1054 18.4804 24.2929 18.2929C24.4804 18.1054 24.7348 18 25 18ZM25 24C25.2652 24 25.5196 24.1054 25.7071 24.2929C25.8946 24.4804 26 24.7348 26 25C26 25.2652 25.8946 25.5196 25.7071 25.7071C25.5196 25.8946 25.2652 26 25 26C24.7348 26 24.4804 25.8946 24.2929 25.7071C24.1054 25.5196 24 25.2652 24 25C24 24.7348 24.1054 24.4804 24.2929 24.2929C24.4804 24.1054 24.7348 24 25 24Z",
    fill: "#F03E3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 14H32V36H35C35.2652 36 35.5196 35.8946 35.7071 35.7071C35.8946 35.5196 36 35.2652 36 35V15C36 14.7348 35.8946 14.4804 35.7071 14.2929C35.5196 14.1054 35.2652 14 35 14Z",
    fill: "#F03E3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem3);
export default __webpack_public_path__ + "static/media/item3.222eea5c7d7e006ce622f0d9aba34daf.svg";
export { ForwardRef as ReactComponent };